import React from 'react'
export default function PartnerNotFound(){
    return  <div style={{height: 700}}>
    <p className={'death-data'} style={{alignSelf: "center", marginTop: 20, marginBottom: 20}}>Partner non trovato</p>
    <p> La pagina da lei richiesta non e' stata trovata</p>
</div>
}